 <template> 
      <!-- <div class="barra"></div> -->
      <section class="position-relative bg-white" id="funciones_principales">
        <div class="container py-5 position-relative">
          <div class="row justify-content-center">
            <div class="col-md-5">
              <h3 class="h3-custom">Crear cuenta</h3>
              <form @submit.prevent="submitForm" novalidate class="row g-3 mt-4"> 
                    <!-- Nombre -->
                    <div class="col-md-6 form-group">
                      <label for="nombre" class="form-label form-label-custom">Nombre</label>
                      <input
                        type="text"
                        v-model="form.nombre"
                        id="nombre"
                        class="form-control  form-control-sm"
                        required
                        :class="{ 'is-invalid': errors.nombre }"
                      />
                      <div class="invalid-feedback" v-if="errors.nombre">
                        Por favor, ingrese su nombre.
                      </div>
                    </div>
  
                    <!-- Apellido -->
                    <div class="col-md-6 form-group">
                      <label for="apellido" class="form-label form-label-custom">Apellido</label>
                      <input
                        type="text"
                        v-model="form.apellido"
                        id="apellido"
                        class="form-control  form-control-sm"
                        required  
                      />
                    </div>

                    <!-- Nombre de la empresa -->
                    <div class="col-md-12 form-group">
                      <label for="empresa" class="form-label form-label-custom">Nombre de la empresa</label>
                      <input
                        type="text"
                        v-model="form.nombre"
                        id="empresa"
                        class="form-control  form-control-sm"
                        required
                        :class="{ 'is-invalid': errors.empresa }" 
                      />
                      <div class="invalid-feedback" v-if="errors.nombre">
                        Por favor, ingrese el nombre de la empresa.
                      </div>
                    </div>

                    <!-- País -->
                    <div class="col-md-6 form-group">
                      <label for="pais" class="form-label form-label-custom">País</label>
                      <select v-model="form.pais" id="pais" class="form-control  form-control-sm" required 
                      :class="{ 'is-invalid': errors.pais }"
                      >
                        <option value="">Seleccione un país</option>
                        <option value="VES">🇻🇪 Venezuela</option>
                        <option value="PA">🇵🇦 Panamá</option>
                      </select> 
                      <div class="invalid-feedback" v-if="errors.pais">
            Por favor, seleccione un país.
          </div>
                    </div>

                     <!-- Cédula/RIF -->
                     <div class="col-md-6 form-group">
                      <label for="cedula" class="form-label form-label-custom">Cédula/RIF</label>
                      <input
                        type="text"
                        v-model="form.rif"
                        id="cedula"
                        class="form-control  form-control-sm" 
                      />
                    </div>
  
                         <!-- Dirección fiscal -->
                    <div class="col-md-12 form-group">
                      <label for="direccion" class="form-label form-label-custom">Dirección fiscal</label>
                      <input
                        type="text"
                        v-model="form.direccion"
                        id="direccion"
                        class="form-control  form-control-sm"
                      />
                    </div>
  
              
  
                    <!-- Correo electrónico -->
                    <div class="col-md-6 form-group">
                      <label for="email" class="form-label form-label-custom">Correo electrónico</label>
                      <input
                        type="email"
                        v-model="form.email"
                        id="email"
                        class="form-control  form-control-sm"
                        :class="{ 'is-invalid': errors.email }" 
                      />
                      <div class="invalid-feedback" v-if="errors.email">
            Por favor, ingrese un correo electrónico válido.
          </div>
                    </div>

                    <!-- Contraseña -->
                    <div class="col-md-6 form-group">
                      <label for="password" class="form-label form-label-custom">Contraseña</label>
                      <div class="input-group input-group-sm">
                        <input
                        :type="showPassword ? 'password' : 'text'" 
                        v-model="form.password"
                        id="password"
                        class="form-control  form-control-sm inputPassword"
                        :class="{ 'is-invalid': errors.password }"
                        required
                      />
                      <div class="input-group-prepend" >
                              <span class="input-group-text iconEye" :class="{ 'invalid-border': errors.password }" id="inputGroup-sizing-sm"><i :class="showPassword ? 'ri-eye-line' : 'ri-eye-off-line'" @click="toggleShowPassword"></i></span>
                            </div> 
                            <div class="invalid-feedback" v-if="errors.password">
                              La contraseña debe tener al menos 8 caracteres, incluir números, letras y un carácter especial.
                            </div> 
                      </div>  
                    </div> 
                    <!-- Teléfono --> 
                    <div class="col-md-6 form-group">
                      <label for="telefono" class="form-label form-label-custom">Teléfono</label>
                      <input
                        type="tel"
                        v-model="form.telefono"
                        id="telefono"
                        class="form-control  form-control-sm"
                        :class="{ 'is-invalid': errors.confirmPassword }"

                      />
                      <div class="invalid-feedback" v-if="errors.telefono">
            Por favor, ingrese un número de teléfono válido.
          </div>
                    </div>

                    <!-- Contraseña repetir-->
                    <div class="col-md-6 form-group">
                      <label for="password" class="form-label form-label-custom">Repetir Contraseña</label>
                      <div class="input-group input-group-sm">
                        <input
                        :type="showPasswordRepeat ? 'password' : 'text'"
                        v-model="form.confirmPassword" 
                        class="form-control  form-control-sm inputPassword"
                        :class="{ 'is-invalid': errors.confirmPassword }"
                        id="confirmPassword"
                        required
                      /> 
                          <div class="input-group-prepend"  >
                              <span class="input-group-text iconEye" :class="{ 'invalid-border': errors.password }"  id="inputGroup-sizing-sm"><i :class="showPasswordRepeat ? 'ri-eye-line' : 'ri-eye-off-line'" @click="toggleShowPasswordRepeat"></i></span>
                            </div> 
                            <div class="invalid-feedback" v-if="errors.confirmPassword">
                                Las contraseñas no coinciden.
                              </div>
                      </div>    
                    </div> 
  
                    <!-- Botón de envío -->
                    <div class="col-12 text-center mt-3 ">
                      <button type="submit" class="btn btn-primary px-5">Enviar</button>
                    </div>
                  </form>
              </div>
            </div>
        </div>
    </section>
</template>
<script> 
import { reactive, ref } from 'vue';

export default {
  name: 'Demo',
  data() {
    return {
      form: {
        pais: "",
        nombre: "",
        email: "",
        direccion: "",
        rif: "",
        telefono: "",
        password: "",
        nombre: "",
        apellido: "",
        confirmPassword: "",
      },
      errors: {
        pais: '',
        nombre: '',
        email: '',
        rif: '',
        telefono: '',
        password: '',
        confirmPassword: '',
        nombre: '', 
      },
      showPassword: false,
      showPasswordRepeat: false,
      emailError: false,
    }
  },
  computed: {
    // Validación para comparar la contraseña y su repetición
    passwordMismatch() {
      return this.form.password !== this.form.confirmPassword;
    },
  },
  methods: {
    validateForm() {
      let isValid = true;

      // Resetear errores
      Object.keys(this.errors).forEach(key => {
        this.errors[key] = '';
      });

      // Validaciones requeridas
      if (!this.form.pais) {
        this.errors.pais = 'Por favor, seleccione un país.';
        isValid = false;
      }

      if (!this.form.empresa) {
        this.errors.empresa = 'Por favor, ingrese el nombre de la empresa.';
        isValid = false;
      }

      if (!this.form.email) {
        this.errors.email = 'Por favor, ingrese un correo electrónico.';
        isValid = false;
      } else if (!this.validateEmail(this.form.email)) {
        this.errors.email = 'Por favor, ingrese un correo electrónico válido.';
        isValid = false;
      }
 
      if (!this.form.telefono) {
        this.errors.telefono = 'Por favor, ingrese un número de teléfono válido.';
        isValid = false;
      }

      if (!this.form.password) {
        this.errors.password = 'Por favor, ingrese una contraseña.';
        isValid = false;
      } else if (!this.validatePassword(this.form.password)) {
        this.errors.password =
          'La contraseña debe tener al menos 8 caracteres, incluir números, letras y un carácter especial.';
        isValid = false;
      }

      if (!this.form.confirmPassword) {
        this.errors.confirmPassword = 'Por favor, repita la contraseña.';
        isValid = false;
      } else if (this.form.password !== this.form.confirmPassword) {
        this.errors.confirmPassword = 'Las contraseñas no coinciden.';
        isValid = false;
      }

      if (!this.form.nombre) {
        this.errors.nombre = 'Por favor, ingrese su nombre.';
        isValid = false;
      }
 

      return isValid;
    },
    validateEmail(email) {
      const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return pattern.test(email);
    },
    validatePassword(password) {
      // Al menos 8 caracteres, una letra mayúscula, una letra minúscula, un número y un carácter especial
      const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^()\-_=+{};:,<.>]).{8,}$/;
      return pattern.test(password);
    },
    // submitForm() {
    //   // Verificación simple de correo
    //   const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    //   this.emailError = !emailPattern.test(this.form.email);

    //   // Si no hay errores en el formulario, continuar con el envío
    //   if (!this.emailError) {
    //     console.log("Formulario enviado:", this.form);
    //     // Aquí puedes añadir la lógica de envío
    //   }
    // },
    async submitForm() { 
      if (this.validateForm()) {
        // Aquí puedes enviar los datos a la API
        this.isLoading = true; 
        try {
          const response = await axios.post('https://v2.alliance-cloud.com/api/api/empresa_demo', this.formData);
          console.log("Respuesta de la API:", response.data);

          alert("Formulario enviado con éxito");
          this.resetForm(); // Limpiar el formulario después del envío
        } catch (error) {
          console.error("Error al enviar los datos:", error);
          alert("Hubo un error al enviar el formulario");
        } finally {
          this.isLoading = false;
        }
        this.resetForm();
      } 
    }, 
    toggleShowPassword() {
      console.log('entro');
      this.showPassword = !this.showPassword; 
    },
    toggleShowPasswordRepeat() {
      console.log('entro');
      this.showPasswordRepeat = !this.showPasswordRepeat;
    },
    resetForm() {
      this.form = {
        pais: "",
        empresa: "",
        email: "",
        direccion: "",
        cedula: "",
        telefono: "",
        password: "",
        nombre: "",
        apellido: "",
        confirmPassword: "",
      }
     this.errors = {
        pais: '',
        empresa: '',
        email: '',
        cedula: '',
        telefono: '',
        password: '',
        confirmPassword: '',
        nombre: '', 
      }
    }
  // setup() {
  //   const form = reactive({
  //     nombre: '',
  //     email: '',
  //     telefono: '',
  //     direccion: '',
  //     ciudad: '',
  //     estado: '',
  //     codigoPostal: '',
  //     pais: '',
  //   });

  //   const errors = reactive({
  //     nombre: '',
  //     email: '',
  //     direccion: '',
  //     ciudad: '',
  //     codigoPostal: '',
  //     pais: '',
  //   });

  //   const validateField = (field) => {
  //     switch (field) {
  //       case 'nombre':
  //         errors.nombre = form.nombre ? '' : 'El nombre es obligatorio.';
  //         break;
  //       case 'email':
  //         errors.email = form.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/) ? '' : 'Ingresa un email válido.';
  //         break;
  //       case 'direccion':
  //         errors.direccion = form.direccion ? '' : 'La dirección es obligatoria.';
  //         break;
  //       case 'ciudad':
  //         errors.ciudad = form.ciudad ? '' : 'La ciudad es obligatoria.';
  //         break;
  //       case 'codigoPostal':
  //         errors.codigoPostal = form.codigoPostal.match(/^\d+$/) ? '' : 'El código postal debe ser numérico.';
  //         break;
  //       case 'pais':
  //         errors.pais = form.pais ? '' : 'El país es obligatorio.';
  //         break;
  //     }
  //   };

  //   const validateForm = () => {
  //     Object.keys(form).forEach((field) => validateField(field));
  //     return !Object.values(errors).some((error) => error);
  //   };

  //   const submitForm = () => {
  //     if (validateForm()) {
  //       alert('Formulario enviado con éxito');
  //       // Aquí se enviaría el formulario o se ejecutaría otra lógica de envío
  //     } else {
  //       alert('Por favor, completa los campos requeridos correctamente.');
  //     }
  //   };

  //   return {
  //     form,
  //     errors,
  //     validateField,
  //     submitForm,
  //   };
  // },
  }
};

</script>

<style scoped lang="scss">

//   @import "../../scss/theme";

  .fontSize45 {
    font-size: 47px
  }

  .barra {
    background-color: theme-color("dark");
    height: 125px;  
  }

  .h3-custom {
    border-bottom: 1px solid #d4d4d4;
    padding-bottom: 10px;
  }

  .form-label-custom {
    margin-bottom:  1px;
    font-size:  13px;
  } 

  .form-group {
        margin-bottom: 7px;
  }

  .iconEye {
    border-left: 0px;
    background-color: #fff;
  }

  .inputPassword {
    border-right: 0px;
  }

  .invalid-border {
    border-color: #dc3545 !important;
  }

  // . form-control-sm {
  //   border-radius: 2px;
  // }
</style>